import React, { useState } from 'react';
import {
  Avatar,
  Button,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material';
import {
  Share,
  Star,
  StarBorder,
  CalendarToday,
  MonetizationOn,
  Group,
  Person
} from '@mui/icons-material';
import MissionDetailsModal from './MissionDetailsModal';
import './MissionCardList.css';

const MissionCardList = ({
  mission,
  isFavorite,
  onToggleFavorite,
  onShare,
  onView
}) => {
  const [logoError, setLogoError] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const logoUrl = mission.logoUrl
    ? `${process.env.REACT_APP_API_BASE_URL}${mission.logoUrl}`
    : '';
  const fallbackInitial = mission.company?.charAt(0)?.toUpperCase() || 'E';
  const devise = mission.devise || '€';

  return (
    <div className={`mission-list-card ${isFavorite ? 'fav-bg' : ''}`}>
      <div className="mission-list-row">
        <div className="mission-logo-block">
          <IconButton onClick={() => onToggleFavorite(mission._id)}>
            {isFavorite ? <Star className="star-active" /> : <StarBorder />}
          </IconButton>
          {!logoError && logoUrl ? (
            <img
              src={logoUrl}
              alt="logo"
              className="mission-logo"
              onError={() => setLogoError(true)}
            />
          ) : (
            <Avatar variant="rounded" className="fallback-avatar">
              {fallbackInitial}
            </Avatar>
          )}
          {mission.isNew && <span className="badge-new-list">NOUVEAU</span>}
        </div>

        <div className="mission-info-content">
          <div className="mission-top-row">
            <Typography variant="h6" className="mission-title">
              {mission.title}
            </Typography>
            <Tooltip title="Partager">
              <IconButton onClick={() => onShare(mission)}>
                <Share fontSize="small" />
              </IconButton>
            </Tooltip>

            <div className="inline-info">
              <span><CalendarToday fontSize="small" className="info-icon" /> <strong>{mission.date}</strong></span>
              <span><MonetizationOn fontSize="small" className="info-icon" /> <strong>{mission.reward} {devise}</strong></span>
              <span>📍 <strong>{mission.location}</strong></span>
              <span><Group fontSize="small" className="info-icon" /> <strong>{mission.filledSpots || 0} / {mission.availableSpots}</strong> profils</span>
              <span><Person fontSize="small" className="info-icon" /> <strong>{mission.candidates}</strong> candidats</span>
            </div>

            <div className="inline-buttons">
              <Button variant="outlined" onClick={() => setShowModal(true)}>Détails</Button>
              <Button variant="contained" onClick={() => onView(mission._id)}>Voir la mission</Button>
            </div>
          </div>

          <Typography className="mission-company">
            <strong>{mission.company}</strong>
          </Typography>
        </div>

        <MissionDetailsModal
          open={showModal}
          onClose={() => setShowModal(false)}
          mission={mission}
        />
      </div>
    </div>
  );
};

export default MissionCardList;

